import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'}`} data-id="element-402">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-403">
        <div className="flex justify-between items-center py-4 md:py-6" data-id="element-404">
          <div className="flex-1 flex justify-center" data-id="element-405">
            <button onClick={scrollToTop} className="flex items-center" aria-label="Scroll to top" data-id="element-406">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aWSGtaZkMPMFTvksK3S2Vo/SS-Horizontal-Lockup_River-Royale.webp" alt="SmartSoda" className="h-10 md:h-12" fetchpriority="high" width="240" height="48" decoding="async" data-id="element-407" />
            </button>
          </div>
        </div>
      </div>
    </header>;
};
export default Navbar;